import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {translations} from 'presentation/translations-new';
import {FlowTypeEnumWithoutAuth} from 'presentation/utils';

const {searchSpecialty, searchProfessional, searchUnit, searchNeighborhood, searchExam} =
	translations['pt-br'].privateFlow.bookingFlow;

export function getSearchPlaceholder(
	flowType: FlowTypeEnumWithoutAuth,
	isUsingGeolocation: boolean,
) {
	const PLACEHOLDER = {
		[FlowEnum.EXAM]: isUsingGeolocation
			? {
					0: '',
					1: searchExam,
					2: searchUnit,
					3: searchProfessional,
					4: '',
				}
			: {
					0: '',
					1: searchExam,
					2: searchNeighborhood,
					3: searchUnit,
					4: searchProfessional,
				},
		[FlowEnum.ODONTO]: isUsingGeolocation
			? {
					0: '',
					1: searchSpecialty,
					2: searchUnit,
					3: searchProfessional,
					4: '',
				}
			: {
					0: '',
					1: searchSpecialty,
					2: searchNeighborhood,
					3: searchUnit,
					4: searchProfessional,
				},
		[FlowEnum.HEALTH]: isUsingGeolocation
			? {
					0: '',
					1: searchSpecialty,
					2: searchUnit,
					3: searchProfessional,
					4: '',
				}
			: {
					0: '',
					1: searchSpecialty,
					2: searchNeighborhood,
					3: searchUnit,
					4: searchProfessional,
				},
		[FlowEnum.TELEHEALTH]: {
			0: searchSpecialty,
			1: searchProfessional,
			2: '',
			3: '',
			4: '',
		},
	};

	return PLACEHOLDER[flowType];
}
